import { useState } from "react";
import { api } from "@/lib/api";
import { ArrowUpRight } from "lucide-react";

const initialState = { name: "", email: "", inquiryType: "Professional conversation", message: "" };
const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function InquiryForm() {
  const [form, setForm] = useState(initialState);
  const [status, setStatus] = useState({ type: "", message: "" });
  const [sending, setSending] = useState(false);

  const update = (event) => {
    const { name, value } = event.target;
    setForm((current) => ({ ...current, [name]: value }));
  };

  const submit = async (event) => {
    event.preventDefault();
    setSending(true);
    setStatus({ type: "", message: "" });
    try {
      await api.post(`${API}/inquiries`, form);
      setForm(initialState);
      setStatus({ type: "success", message: "Your note has been received. Thank you for starting the conversation." });
    } catch (error) {
      setStatus({ type: "error", message: "The note could not be sent just now. Please try again shortly." });
    } finally {
      setSending(false);
    }
  };

  return (
    <form className="inquiry-form" id="contact-form" onSubmit={submit} data-testid="inquiry-form">
      <h2 className="form-heading">Tell me what you are thinking about.</h2>
      <div className="form-grid">
        <label className="form-field">
          <span className="form-label">Your name</span>
          <input className="form-input" name="name" value={form.name} onChange={update} required data-testid="inquiry-name-input" />
        </label>
        <label className="form-field">
          <span className="form-label">Your email</span>
          <input className="form-input" type="email" name="email" value={form.email} onChange={update} required data-testid="inquiry-email-input" />
        </label>
        <label className="form-field full">
          <span className="form-label">What brings you here?</span>
          <select className="form-select" name="inquiryType" value={form.inquiryType} onChange={update} data-testid="inquiry-type-select">
            <option>Professional conversation</option>
            <option>Speaking opportunity</option>
            <option>Research or industry discussion</option>
            <option>Technology leadership connection</option>
          </select>
        </label>
        <label className="form-field full">
          <span className="form-label">Your note</span>
          <textarea className="form-textarea" name="message" value={form.message} onChange={update} placeholder="A question, an idea, or a problem you are working through" required data-testid="inquiry-message-input" />
        </label>
      </div>
      <div className="form-footer">
        <button className="button-primary" type="submit" disabled={sending} data-testid="inquiry-form-submit-button">
          {sending ? "Sending…" : "Send the note"} <ArrowUpRight size={15} />
        </button>
        <p className={`form-status ${status.type}`} role="status" data-testid="inquiry-form-status">{status.message}</p>
      </div>
    </form>
  );
}
